import client from "@/client/publicApiClient.ts";
import { useMutation } from "@tanstack/react-query";
import type { ChangeIdentityPasswordMutationRequest, ChangeIdentityPasswordMutationResponse } from "../types/ChangeIdentityPassword";
import type { UseMutationOptions } from "@tanstack/react-query";

 type ChangeIdentityPasswordClient = typeof client<ChangeIdentityPasswordMutationResponse, never, ChangeIdentityPasswordMutationRequest>;
type ChangeIdentityPassword = {
    data: ChangeIdentityPasswordMutationResponse;
    error: never;
    request: ChangeIdentityPasswordMutationRequest;
    pathParams: never;
    queryParams: never;
    headerParams: never;
    response: ChangeIdentityPasswordMutationResponse;
    client: {
        parameters: Partial<Parameters<ChangeIdentityPasswordClient>[0]>;
        return: Awaited<ReturnType<ChangeIdentityPasswordClient>>;
    };
};
/**
 * @summary Change password
 * @link /api/identity/change-password
 */
export function useChangeIdentityPassword(options: {
    mutation?: UseMutationOptions<ChangeIdentityPassword["response"], ChangeIdentityPassword["error"], ChangeIdentityPassword["request"]>;
    client?: ChangeIdentityPassword["client"]["parameters"];
} = {}) {
    const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};
    return useMutation({
        mutationFn: async (data) => {
            const res = await client<ChangeIdentityPassword["data"], ChangeIdentityPassword["error"], ChangeIdentityPassword["request"]>({
                method: "post",
                url: `/api/identity/change-password`,
                data,
                headers: { "Content-Type": "text/json", ...clientOptions.headers },
                ...clientOptions
            });
            return res.data;
        },
        ...mutationOptions
    });
}